import { useTheme } from '@emotion/react'
import { isEmpty } from '@open-tender/utils'
import { selectTags, useAppSelector } from '@open-tender/cloud'
import {
  MenuItemTag,
  MenuItemTagImage,
  MenuItemTagImageAndText,
  MenuItemTagsView,
} from './MenuItemTags.styled'

const TagImage = ({ tag }: { tag: string }) => {
  const { lookup } = useAppSelector(selectTags)
  return (
    <MenuItemTagImage key={tag}>
      <img src={lookup[tag]?.imageUrl} alt={lookup[tag]?.name} />
    </MenuItemTagImage>
  )
}

const MenuItemTags = ({ tags }: { tags: string[] }) => {
  const theme = useTheme()
  const { displayType, prefix } = theme.menuItems.tags
  const { lookup } = useAppSelector(selectTags)
  const hasLookup = lookup && !isEmpty(lookup)
  const showTagImages = hasLookup && displayType === 'IMAGE'
  const showBoth = hasLookup && displayType === 'BOTH'
  const tagsString = prefix ? `${prefix} ${tags.join(', ')}` : null

  if (!tags.length || displayType === 'HIDDEN') return null

  return (
    <MenuItemTagsView>
      {showTagImages ? (
        tags.map((tag) => <TagImage key={tag} tag={tag} />)
      ) : showBoth ? (
        <>
          {tags.map((tag) => (
            <MenuItemTagImageAndText key={tag}>
              <TagImage tag={tag} />
              <MenuItemTag>{tag}</MenuItemTag>
            </MenuItemTagImageAndText>
          ))}
        </>
      ) : tagsString ? (
        <MenuItemTag>{tagsString}</MenuItemTag>
      ) : (
        tags.map((tag) => <MenuItemTag key={tag}>{tag}</MenuItemTag>)
      )}
    </MenuItemTagsView>
  )
}

export default MenuItemTags
